import { render, staticRenderFns } from "./widget-info.vue?vue&type=template&id=24e7b827&scoped=true&"
import script from "./widget-info.vue?vue&type=script&lang=js&"
export * from "./widget-info.vue?vue&type=script&lang=js&"
import style0 from "./widget-info.vue?vue&type=style&index=0&id=24e7b827&scoped=true&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e7b827",
  null
  
)

export default component.exports